module.exports = "<div id=\"dev-studio\" class=\"ds\"></div>"